import {PregnancyListJson} from "../../../api/generated/medical-rest";
import {EventBusy, Flare, SportsScoreOutlined} from "@mui/icons-material";
import {SvgIcon} from "@mui/material";
import React from "react";
import {ReactComponent as MatingDateSvg} from "../../../icons/mating_date.svg"
import {getPregnancyState, PregnancyState} from "./pregnancy-utils";

type PregnancyDates = Pick<PregnancyListJson, 'matingDate' | 'startDate' | 'actualEndDate'>;

export const PregnancyIcon = ({pregnancy}: { pregnancy: PregnancyDates }) => {
    const pregnancyState = getPregnancyState(pregnancy);
    switch (pregnancyState) {
        case PregnancyState.PREGNANT: return <Flare/>;
        case PregnancyState.MATED: return <SvgIcon><MatingDateSvg/></SvgIcon>;
        case PregnancyState.UNSUCCESSFUL: return <EventBusy/>;
        case PregnancyState.COMPLETED: return <SportsScoreOutlined/>;
        default: return null;
    }
}

